// 🎯 커스텀 봇 타입
export const CUSTOM_BOT_TYPE = {
  OPTIONS: 'OPTIONS', // 옵션 중 랜덤 선택
  FORMULA: 'FORMULA', // 수식 실행
  DICE: 'DICE', // 주사위 (nDm 형식)
} as const;

export type CUSTOM_BOT_TYPE_VALUE =
  typeof CUSTOM_BOT_TYPE[keyof typeof CUSTOM_BOT_TYPE];

// 🎯 커스텀 봇 인터페이스
export interface ICustomBot {
  id?: string;
  objectID?: string;

  // 기본 정보
  value: string; // 봇 이름 (약칭) - 예: '홀짝', 'r1d100'
  description?: string; // 설명 - 예: '홀짝 게임', '100면체 주사위 1개'
  type: CUSTOM_BOT_TYPE_VALUE; // 봇 타입

  // Options 타입인 경우
  options?: string[]; // 선택지 목록 - 예: ['홀', '짝', '무승부']

  // Formula 타입인 경우
  formula?: string; // 수식 - 예: 'Math.floor(Math.random() * 100) + 1'

  // 메타 정보
  createdAt?: Date;
  editedAt?: Date;
  authorUid?: string; // 생성자 (마스터만 가능)
  isActive: boolean; // 활성화 여부
  usageCount?: number; // 사용 횟수
}

// 🎯 봇 실행 결과
export interface IBotExecutionResult {
  botId: string; // 봇 ID
  botValue: string; // 봇 이름
  result: string | number; // 실행 결과
  executedAt: Date; // 실행 시간
  type: CUSTOM_BOT_TYPE_VALUE; // 봇 타입
}

// 🎯 게시글에 포함된 봇 결과
export interface IThreadBotResult {
  [botValue: string]: {
    // 봇 이름을 key로
    result: string | number; // 결과값
    type: CUSTOM_BOT_TYPE_VALUE; // 봇 타입
    executedAt: Date; // 실행 시간
  };
}
